/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExcludeEntityId
 */
export interface ExcludeEntityId {
}

/**
 * Check if a given object implements the ExcludeEntityId interface.
 */
export function instanceOfExcludeEntityId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExcludeEntityIdFromJSON(json: any): ExcludeEntityId {
    return ExcludeEntityIdFromJSONTyped(json, false);
}

export function ExcludeEntityIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExcludeEntityId {
    return json;
}

export function ExcludeEntityIdToJSON(value?: ExcludeEntityId | null): any {
    return value;
}

